import React, { Fragment, useEffect, useRef, useState } from 'react';
import { Button } from 'react-bootstrap';
import { BsCheck, BsPencil, BsTrash } from 'react-icons/bs';
import { connect, useDispatch } from 'react-redux';
import { Link } from 'react-router-dom';

import * as _ from 'lodash';
import { setCategory, setToast } from '../../../../containers/client/actions';
import { saveState } from '../../../../lib/storages';
import { translate } from 'react-i18next';
import { makeGetCategory, makeGetToken } from '../../../../lib/selector';
import RenderFieldInput from '../../../input/renderFieldInput';
import { maxLength, required } from '../../../../utils/validation';
import { change, Field, reduxForm } from 'redux-form';

const maxLength20 = maxLength(20);

function ItemWatchListNew(props) {
  const dispatch = useDispatch();
  const wrapperRef = useRef();

  const [isChange, setIsChange] = useState(false);
  const [idCtlSel, setIdCtlSel] = useState(null);

  const { handleSubmit, pristine, submitting, t } = props;

  useEffect(() => {
    window.addEventListener('mousedown', handleClickOutside);
    // See note below
    return () => window.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const _handleDelCategory = (categoryId) => {
    const { category, t } = props;
    let _category = [...category];
    if (
      _.some(_category, (o) => o.id === categoryId) &&
      categoryId !== 'mac-dinh'
    ) {
      _.remove(_category, (o) => o.id === categoryId);
      // save
      dispatch(setCategory(_category));
      saveState('category', _category);
    } else {
      const toastMsg = {
        id: Math.random(),
        msg: t('txt-valid-not-del') + categoryId,
        title: t('txt-notice'),
      };
      dispatch(setToast(toastMsg));
    }
  };

  const handleClickOutside = (event) => {
    if (
      wrapperRef &&
      wrapperRef.current &&
      !wrapperRef.current.contains(event.target)
    ) {
      setIsChange(false);
    }
  };

  const submit = (value) => {
    const { categoryName } = value;
    const { category, reset } = props;

    if (
      _.some(category, (o) => o.type === 'watchlist' && o.name === categoryName)
    ) {
      const toastMsg = {
        id: Math.random(),
        msg: t('txt-valid-exist-category') + categoryName,
        title: t('txt-notice'),
      };
      dispatch(setToast(toastMsg));
      return;
    }

    let _newCategory = [...category];
    _newCategory.map((element) => {
      if (element.id !== idCtlSel) return element;

      element.name = categoryName;
      return element;
    });
    const _categorySelected = _.find(
      _newCategory,
      (o) => o.id === idCtlSel && o.type === 'watchlist'
    );
    if (_categorySelected) {
      //   let _obj = Object.assign({}, _categorySelected);
      //   _obj.name = categoryName;
      dispatch(setCategory(_newCategory));
      saveState('category', _newCategory);
      reset();
      setIsChange(false);
      setIdCtlSel(null);
    }

    console.log(category, categoryName);

    return;
  };

  const _handleChangeName = (id) => {
    setIsChange(true);
    setIdCtlSel(id);
    const { category } = props;
    const _catalog = _.find(
      category,
      (o) => o.type === 'watchlist' && o.id === id
    );
    dispatch(change('editCatalog', 'categoryName', _catalog?.name || ''));
  };

  return (
    <div
      className={
        'd-flex nav-item-drop ' +
        (props.categoryId === props.record.id ? 'active' : '')
      }
    >
      {!isChange && (
        <Link to={props.record.path} className="nav-link">
          {props.record.name}
        </Link>
      )}
      {isChange && (
        <form
          ref={wrapperRef}
          onSubmit={handleSubmit(submit)}
          className="d-flex"
        >
          <Field
            name="categoryName"
            type="text"
            id="categoryName"
            className="field-change-catalog"
            placeholder={t('txt-portfolio')}
            component={RenderFieldInput}
            validate={[required, maxLength20]}
          />
          <Button
            variant="secondary"
            type="submit"
            disabled={pristine || submitting}
            className="mr-1 ml-1 btn-drop"
          >
            <BsCheck className="text-white" />
          </Button>
        </form>
      )}
      <div className="d-flex">
        {!isChange && props.record.id !== 'mac-dinh' && (
          <Fragment>
            <Button
              variant="secondary"
              className="mr-1 btn-drop"
              onClick={() => _handleChangeName(props.record.id)}
            >
              <BsPencil />
            </Button>
            <Button
              variant="secondary"
              className="mr-1 btn-drop"
              onClick={() => _handleDelCategory(props.record.id)}
            >
              <BsTrash />
            </Button>
          </Fragment>
        )}
      </div>
    </div>
  );
}

const makeMapStateToProps = () => {
  const getToken = makeGetToken();
  const getCategory = makeGetCategory();

  const mapStateToProps = (state) => {
    return {
      token: getToken(state),
      category: getCategory(state),
    };
  };
  return mapStateToProps;
};

const connected = connect(makeMapStateToProps)(ItemWatchListNew);

const formed = reduxForm({
  form: 'editCatalog',
})(connected);

export default translate('translations')(formed);
